import * as uuid from 'uuid';
import startCase from 'lodash/startCase';

export const formatName = prop => {
  return prop && startCase(prop.toString().replace(/_/g, ' '));
};

export const groupLogs = (logs, sections = []) => {
  const groupedLogs = [];

  if (logs && logs.length > 0) {
    logs.forEach((log, index) => {
      const { action: actionEnum } = log;
      const section = sections.find(item => item.actions.includes(log.action?.id)) || { name: actionEnum?.name };
      const lastGroupElement = groupedLogs.length > 0 && groupedLogs[groupedLogs.length - 1];
      const prevLog = logs[index - 1] || {};
      const sectionBasedOnPrevLog = sections.find(item => item.actions.includes(prevLog.action)) || {
        name: actionEnum?.name,
      };

      /*
        Check whether the prev log element belonged to the same group based on the last group element.
        If yes push the log element to this group
      */
      if (lastGroupElement && sectionBasedOnPrevLog.name === lastGroupElement.name) {
        lastGroupElement.nestedDataSource.push(log);
        // else create new group
      } else {
        groupedLogs.push({ id: uuid.v4(), name: section.name, nestedDataSource: [log] });
      }
    });
  }

  return groupedLogs;
};
